const PREFIX_URL = `${window.APP.apiURL}/_exclusive/mitra-wallet`
const SCOPE = 'user'
const params = { product_type: 'government-revenue' }

export default {
  getWhitelist() {
    return this.get(`${PREFIX_URL}/whitelist`, SCOPE, {
      responseErrorJson: true,
      enableAuthHeader: true,
      params,
    })
  },
}
